export default __webpack_public_path__ + "img/lips.0d3633c2.svg";